import React from 'react';
import CallActions from './call-actions';
import { Typography, Grid } from '@mui/material';
import { CallBox, CallHeader, CallDetails, CallStateActive, CallStateOnhold, CallButton } from './call-styles';
import { Phone } from '@mui/icons-material';
import { useCallSelector, usePhoneActions } from '../../hooks/use-phone';
import { useCallIdentity } from '../../hooks/use-call-identity';
import { formatUSPhoneNumber } from '../../utils/formatter';
import Elapsed from '../elapsed';

export default function CallInProgress(props: { callId: string }) {
  const remoteIdentity = useCallSelector(props.callId, (x) => x.remoteIdentity);
  const established = useCallSelector(props.callId, (x) => x.established);
  const onHold = useCallSelector(props.callId, (x) => x.onHold);
  const { contactNames } = useCallIdentity({ phoneNumber: remoteIdentity as string });
  const { cancel } = usePhoneActions();

  return (
    <CallBox data-testid="call-inprogress">
      <CallHeader>
        <Grid container>
          <Grid item xs={10} zeroMinWidth>
            {onHold ? <CallStateOnhold>ON HOLD</CallStateOnhold> : <CallStateActive>CALL IN PROGRESS</CallStateActive>}
            <Typography variant="h6" noWrap>
              {contactNames ? contactNames : ''}
            </Typography>
            <Typography variant="body2">{formatUSPhoneNumber(remoteIdentity)}</Typography>
            <Typography variant="body2">{!!established && <Elapsed from={established} />}</Typography>
          </Grid>
          <Grid item xs={2} style={{ textAlign: 'right' }}>
            <CallButton
              onClick={() => cancel(props.callId)}
              sx={{ backgroundColor: 'rgb(244, 73, 72)', '&:hover': { backgroundColor: 'rgb(244, 73, 72)' } }}
            >
              <Phone sx={{ transform: 'rotate(135deg)' }} />
            </CallButton>
          </Grid>
        </Grid>
      </CallHeader>
      <CallDetails>
        <CallActions {...props} />
      </CallDetails>
    </CallBox>
  );
}
